import React from 'react';
import { EligibilityStatus } from 'types/uwService';
import { CheckCircle, NavigationClose, WarningFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { UwStatusStyled, UwStatusWrapperStyled } from './styles';

interface Props {
  status: EligibilityStatus;
  message: string;
}

const ICONS: Record<EligibilityStatus, JSX.Element> = Object.freeze({
  ELIGIBLE: <CheckCircle width="2.3rem" color={colors.green[600]} />,
  UPDATED_RATES: <WarningFilled width="2.3rem" color={colors.orange[500]} />,
  NOT_ELIGIBLE: <NavigationClose width="2.3rem" color={colors.red[600]} />,
  OVERRIDE: <WarningFilled width="2.3rem" color={colors.purple[500]} />,
});

const UwValidationResult: React.FC<Props> = ({ status, message }) => {
  return (
    <UwStatusWrapperStyled>
      <div>{ICONS[status]}</div>
      <UwStatusStyled>{message}</UwStatusStyled>
    </UwStatusWrapperStyled>
  );
};

export default UwValidationResult;
